import React from 'react';

import Finished from './Finished';
import OutOfPlan from './OutOfPlan';
import Canceled from './Canceled';

const DeliveryItem = ({ data }) => {

    switch(data.type) {
        case 'out_of_plan':
            return (<OutOfPlan data={data} />);

        case 'canceled':
            return (<Canceled data={data} />);

        default:
            return (<Finished data={data} />);
    }

}

export default DeliveryItem;



// WEBPACK FOOTER //
// ./src/components/Timeline/Delivery/index.js